<template>
  <div class="cp-mobility-testimonials">
    <div class="teq-container">
      <div class="icon-container">
        <svg class="icon">
          <use
            xlink:href="#icon-mobilize-share"
          ></use>
        </svg>
      </div>
      <h2>ils ont testé et validé Mobilize Share</h2>
      <div class="flex-container">
        <div class="item">
          <h3>louer en libre service</h3>
          <blockquote>“Je n'ai pas de véhicule personnel. Mobilize Share me permet de louer un véhicule ponctuellement, quand j'en ai besoin, et sans être contraint par les horaires d'ouverture d'une agence de location classique.”</blockquote>
          <div class="bottom-content">
            <div class="car-detail-container">
              <div class="car-detail">
                ZOE
              </div>
              <div class="car-detail">
                2 HEURES
              </div>
              <div class="car-detail">
                100 KM
              </div>
            </div>
            <div class="bottom-container">
              <div class="price">
                14 €
              </div>
              <arrow-link :href="'/libre-service'" />
            </div>
          </div>
        </div>
        <div class="item">
          <h3>louer en agence</h3>
          <blockquote>"Je suis propriétaire d'un véhicule de type citadine. Grâce à Mobilize Share, je peux louer un monospace pour partir en week-end, et être accompagné par un conseiller location lors de la restitution de véhicule."</blockquote>
          <div class="bottom-content">
            <div class="car-detail-container">
              <div class="car-detail">
                NOUVEAU SCENIC
              </div>
              <div class="car-detail">
                WEEK-END
              </div>
              <div class="car-detail">
                400 KM
              </div>
            </div>
            <div class="bottom-container">
              <div class="price">
                129 €
              </div>
              <arrow-link :href="'/location-en-agence'" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowLink from '../shared/ArrowLink'

export default {
  name: 'MobilityTestimonials',

  props: {
    isMobility: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ArrowLink,
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.cp-mobility-testimonials {
  background: #f5f5f5;
  box-sizing: border-box;
  padding: 5.5rem 0 3rem;

  @include teq-breakpoint($large) {
    padding: 7.8rem 0 6rem;
  }
}

// .teq-container {

// }

.flex-container {
  @include teq-breakpoint($large) {
    align-items: stretch;
    display: flex;
    justify-content: space-between;
  }
}

.item {
  background: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 2rem 4rem;

  &:first-child {
    margin-bottom: 2rem;
  }

  @include teq-breakpoint($large) {
    padding: 4rem;
    width: calc(50% - 1rem);

    &:first-child {
      margin-bottom: 0;
    }
  }
}

h2 {
  font-family: $f-graphie-bold;
  font-size: 4rem;
  line-height: 120%;

  @include teq-breakpoint($large) {
    font-size: 5.6rem;
    line-height: 100%;
  }
}

h3 {
  color: #000;
  font-family: $f-graphie-book;
  font-size: 2rem;
  line-height: 2.7rem;
  //text-transform: uppercase;

  @include teq-breakpoint($large) {
    margin-bottom: 4rem;
  }
}

blockquote {
  color: #000;
  font-family: $f-graphie-semibold;
  font-size: 1.6rem;
  font-style: italic;
  line-height: 2.8rem;
  margin-bottom: 5rem;
  position: relative;

  &::before {
    background: #000;
    bottom: -2.5rem;
    content: '';
    height: 2px;
    left: 0;
    position: absolute;
    width: 4.2rem;

    @include teq-breakpoint($large) {
      display: none;
    }
  }

  &::after {
    background: transparent url("data:image/svg+xml,%3Csvg id='Layer_1' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68 75'%3E%3Cpath d='M16.62,0H31.24L18.39,75H0ZM53.38,0H68L55.15,75H36.76Z' transform='translate(0 0)' fill-opacity='0.04'/%3E%3C/svg%3E") no-repeat left top / contain;
    content: '';
    height: 7.5rem;
    left: -1.8rem;
    position: absolute;
    top: -2.8rem;
    width: 6.8rem;

    @include teq-breakpoint($large) {
      background: transparent url("data:image/svg+xml,%3Csvg width='102' height='75' viewBox='0 0 102 75' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M24.9265 0H46.8618L27.5853 75H0L24.9265 0ZM80.0647 0H102L82.7235 75H55.1382L80.0647 0Z' fill='black' fill-opacity='0.06'/%3E %3C/svg%3E") no-repeat left top / contain;
      height: 7.5rem;
      width: 10.2rem;
    }
  }
}

.car-detail-container {
  display: flex;
  margin-bottom: 2rem;
}

.car-detail {
  color: #878785;
  font-family: $f-graphie-semibold;
  font-size: 1.2rem;
  line-height: 1.8rem;
  margin-right: 1.5rem;
  overflow: visible;
  position: relative;
  text-transform: uppercase;

  &::before {
    background: #ddd;
    content: '';
    height: 1.2rem;
    position: absolute;
    right: -9px;
    top: 2px;
    width: 2px;
  }

  &:last-child {
    &::before {
      display: none;
    }
  }
}

.bottom-content {
  margin-top: auto;
}

.bottom-container {
  margin-bottom: 2rem;

  @include teq-breakpoint($large) {
    display: flex;
    justify-content: space-between;
  }
}

.price {
  color: #000;
  font-family: $f-graphie-semibold;
  font-size: 1.8rem;
  line-height: 2.4rem;
  margin-bottom: 3rem;
  padding-left: 1.5rem;
  position: relative;
  text-transform: uppercase;

  &::before {
    background: $orange;
    content: '';
    height: 3rem;
    left: 0;
    position: absolute;
    top: -0.6rem;
    width: 2px;
  }
}

.icon-container {
  text-align: center;

  .icon {
    height: 53.5px;
    width: 60px;

    @include teq-breakpoint($large) {
      height: 66px;
      width: 74px;
    }
  }
}

</style>
